import { mapState } from 'vuex';
export default {
  name: 'CustomCode',
  props: {
    block: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('app', ['UiTheme']),
    modeClass() {
      return this.UiTheme ? 'dark' : 'light';
    }
  }
};